import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import posed from 'react-pose';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import { breakpoints, palette } from '../../constants/styles';
import { mp } from '../../constants/utils';

import Button from './Button';
import Icon from './Icon';
import {phoneNumber} from "../../constants/constants";

const ExternalLinkInitialCTA = styled.a`
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  ${({ bottom }) =>
    bottom &&
    css`
      ${breakpoints.tabletLandscape} {
        justify-content: center;
      }
    `}

  ${({ styles }) => styles}
`;

const InternalLinkInitialCTA = styled(Link)`
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  ${({ bottom }) =>
    bottom &&
    css`
      ${breakpoints.tabletLandscape} {
        justify-content: center;
      }
    `}

  ${({ styles }) => styles}
`;

const ButtonInitialCTA = styled(Button)`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 50px;
  font-size: 20px;
  margin: 0px 0px;
  padding: 0 20px;
  line-height: 30px;
  width: fit-content;
  font-weight: 700;
  background-color: ${palette.preClick};

  &:hover {
    background-color: ${palette.primaryColor};
  }

  ${({ styles }) => styles}
`;

const Box = posed.div({
  on: {
    scale: 1,
  },
  off: {
    scale: 1.1,
    transition: {
      type: 'spring',
      stiffness: 1000,
      delay: 1700,
      duration: 0.5,
    },
  },
});

const generateMessage = (message) =>
  `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

function getLink(message, customLink) {
  let link = '';
  if (customLink === '') {
    link = window.innerWidth < 570 ? generateMessage(message) : 'https://m.me/finautamx';
  }
  return link;
}

function getIcon(customIcon) {
  let icon = '';
  if (customIcon === 'message') {
    icon = window.innerWidth < 570 ? 'whatsapp' : 'messenger';
  } else {
    icon = customIcon;
  }
  return icon;
}

class CTAButton extends Component {
  state = {
    isVisible: true,
  };

  componentDidMount() {
    setInterval(() => {
      this.setState({ isVisible: !this.state.isVisible });
    }, 2000);
  }

  render() {
    const {
      externalLink,
      internalLink,
      message,
      event,
      linkStyles,
      buttonStyles,
      buttonText,
      customMessage,
      icon,
      nolink,
      blank,
      customOnClick,
      forced,
    } = this.props;
    const { isVisible } = this.state;

    return (
      <Fragment>
        {internalLink === '' ? (
          <ExternalLinkInitialCTA
            // eslint-disable-next-line no-nested-ternary
            href={message !== '' ? getLink(message, externalLink) : nolink ? '#' : externalLink}
            onClick={() => {
              customOnClick();
              mp(event);
            }}
            rel="noopener noreferrer"
            target={blank ? '_blank' : ''}
            styles={linkStyles}
          >
            <ButtonInitialCTA styles={buttonStyles} maxWidth={500}>
              <Box className="box" pose={isVisible ? 'on' : 'off'}>
                {icon ? (
                  <Icon
                    icon={getIcon(icon)}
                    size={25}
                    color="white"
                    styles={css`
                      margin-right: 10px;
                      margin-bottom: -6px;
                    `}
                  />
                ) : (
                  <Fragment />
                )}
              </Box>
              {buttonText}
            </ButtonInitialCTA>
          </ExternalLinkInitialCTA>
        ) : (
          <InternalLinkInitialCTA
            onClick={
              forced
                ? () => {
                    mp(event);
                    this.forceUpdate();
                  }
                : () => {
                    mp(event);
                  }
            }
            to={{
              pathname: internalLink,
              state: {
                customMessage,
              },
            }}
            styles={linkStyles}
          >
            <ButtonInitialCTA styles={buttonStyles} maxWidth={500}>
              <Box className="box" pose={isVisible ? 'on' : 'off'}>
                {icon ? (
                  <Icon
                    icon={getIcon(icon)}
                    size={25}
                    color="white"
                    styles={css`
                      margin-right: 10px;
                      margin-bottom: -6px;
                    `}
                  />
                ) : (
                  <Fragment />
                )}
              </Box>
              {buttonText}
            </ButtonInitialCTA>
          </InternalLinkInitialCTA>
        )}
      </Fragment>
    );
  }
}

CTAButton.propTypes = {
  message: PropTypes.string,
  event: PropTypes.string,
  buttonText: PropTypes.string,
  internalLink: PropTypes.string,
  externalLink: PropTypes.string,
  customMessage: PropTypes.string,
  pixelID: PropTypes.string,
  icon: PropTypes.string,
  linkStyles: PropTypes.array,
  buttonStyles: PropTypes.array,
  customOnClick: PropTypes.func,
  nolink: PropTypes.bool,
  forced: PropTypes.bool,
};

CTAButton.defaultProps = {
  message: '',
  customOnClick: () => {},
  pixelID: '2298702030410960',
  nolink: false,
  event: '',
  buttonText: 'Conversemos',
  customMessage: 'TemplateMessage',
  internalLink: '',
  externalLink: '',
  icon: '',
  linkStyles: [],
  buttonStyles: [],
  forced: false,
};

export default CTAButton;
